$(document).ready(function() {
 
  function cartItemLoop() { 
    var var_id = $('label[for=CartShippingProtection]').attr('data-varid');
    if ($('[data-products]').find('.cart__item').length > 1) {
    $('[data-products] .cart__item').each(function() { 
     if ($(this).data('id') == var_id){  
        if (window.location.pathname == '/cart'){   
       $('label[for=CartShippingProtection]').addClass("is__added");
       $('label[for=CartShippingProtection] input[type="checkbox"]').attr('checked', 'checked');
      } }
      });
    }  else {
     $('[data-products] .cart__item').each(function() {
     if ($(this).data('id') == var_id){
     $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {  id: var_id, quantity: 0 }, 
      success: function(product){  
      console.log("Remove This Item");
       document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: this.addToCart
          }
        }));
      },
      error: function(){ 
       console.log("Add to cart  Errors");
      }
    });
   }
   }); 
 }
 }
var interval = self.setInterval(function(){cartItemLoop()},80);
  
$(document).on('click','label[for=CartShippingProtection]',function(evt){
   evt.preventDefault();
 var var_id = $(this).attr('data-varid');     
if($(this).hasClass("is__added")) {
  $(this).removeClass("is__added");
 $('label[for=CartShippingProtection] input[type="checkbox"]').removeAttr('checked');
   $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {  id: var_id, quantity: 0 }, 
      success: function(product){  
      console.log("Remove This Item"); 
      if (window.location.pathname == '/cart'){ 
      window.location.href = '/cart';
      } else {
       document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
        product: product,
        addToCartBtn: this.addToCart
        }
      }));
      }
      },
      error: function(){ 
       console.log("Add to cart  Errors"); 
      }
    });
} else {
  $(this).addClass("is__added");
  $('label[for=CartShippingProtection] input[type="checkbox"]').attr('checked', 'checked');
   $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {  id: var_id, quantity: 1 },
      success: function(product){  
      console.log("Add to cart success");
      if (window.location.pathname == '/cart'){ 
      window.location.href = '/cart'
      } else {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: product,
        addToCartBtn: this.addToCart
      }
      }));
      }
      },
      error: function(){ 
       console.log("Add to cart  Errors"); 
      }
    });
}
 
});

  $(document).on('click','span.labelProtectiontext',function(evt){
     evt.preventDefault();
  $('.labelProtectionContent').addClass('is_active');
    });
  $(document).on('click','span.labelProtectionback',function(){
  $('.labelProtectionContent').removeClass('is_active');
});

  
function cartDrawerShippingLoop() {
    if ($('.custom--shippingBar').length > 0) {
      $('.custom--shippingBar').load(window.location.href+ ' .custom--shippingBar >*', '');
      clearInterval(interval);
    } 
}
var interval = self.setInterval(function(){cartDrawerShippingLoop()},80);   


  $('.okeReviews-reviewsSummary').click(function(){
     $('.hj-custom-review--tab .collapsible-trigger').trigger("click");
  });
  
});


function updateShippingBar() {
  if ($('.custom--shippingBar').length > 0) {
    $('.custom--shippingBar').load(window.location.href + ' .custom--shippingBar >*', '');
  }
}

// On page load
$(document).ready(function() {
  updateShippingBar(); // optional first load

  // Listen for custom cart updates
  document.addEventListener('ajaxProduct:added', function() {
    updateShippingBar();
  });
});


let lastCartJSON = null;

function pollCart() {
  $.getJSON('/cart.js', function(cart) {
    const cartString = JSON.stringify(cart.items);
    if (cartString !== lastCartJSON) {
      lastCartJSON = cartString;
      updateShippingBar();
    }
  });
}

setInterval(pollCart, 1000); // check every 1 second